module.exports = __webpack_public_path__ + "img/chongzhi.e7110932.png";